import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 11,
	viewBox: "0 0 11 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5078 4.37305V6.07227H0.761719V4.37305H10.5078ZM6.54297 0.222656V10.5742H4.73633V0.222656H6.54297Z",
		fill: "#0066FF"
	})
});
export default SvgPlus;
